import { css } from '@emotion/css'
import { spacing, fontSize, fontWeight } from '@offerzen/pinata-shame'

const styles = {
  listMetaData: css({
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  }),

  heading: css({
    fontSize: fontSize.default,
  }),

  sortingText: css({
    fontSize: fontSize.small,
    fontWeight: fontWeight.medium,
    textAlign: 'right',
    marginBottom: spacing.small,
  }),

  list: css({
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.default,
  }),

  pagination: css({
    marginTop: spacing.large,
  }),
}

export default styles
